import { useDeviceType } from '@cian/ui-kit';
import { FC } from 'react';
import { HouseSubscriptionBanner, HouseSubscriptionBannerMobile } from 'shared/components/HouseSubscription';
import { NBSP } from 'shared/constants/symbols';

interface IHouseSubscriptionBannerContainerProps {
  onClick: VoidFunction;
}

export const HouseSubscriptionBannerContainer: FC<IHouseSubscriptionBannerContainerProps> = ({ onClick }) => {
  const deviceType = useDeviceType();

  const HouseSubscriptionBannerComponent =
    deviceType === 'desktop' ? HouseSubscriptionBanner : HouseSubscriptionBannerMobile;

  return (
    <HouseSubscriptionBannerComponent
      title="Хотите жить в этом доме?"
      subtitle={`Подпишитесь на новые объявления о продаже или${NBSP}аренде квартир`}
      buttonText="Подписаться"
      onClick={onClick}
    />
  );
};
